import {PartnerCostsPath} from './routePaths';

const navHorizontalOptions = [
  {
    name: 'Vehicle costs',
    path: PartnerCostsPath.vehicleCosts
  },
  {
    name: 'Driver costs',
    path: PartnerCostsPath.driverCosts
  }
];

export default navHorizontalOptions;
